import * as Icons from "lucide-react";

export function CaseProcessing() {
  return (
    <div className="max-w-2xl mx-auto p-10 text-center" data-testid="ca-processing">
      <Icons.Brain className="h-12 w-12 text-blue-600 mx-auto mb-4 animate-pulse" />
      <h2 className="text-xl font-bold text-slate-900 mb-1">Allison is analyzing the transcript…</h2>
      <p className="text-slate-500">Extracting client details, mapping services, estimating pricing, and drafting your estimate. This usually takes under a minute.</p>
      <Icons.Loader2 className="h-6 w-6 animate-spin text-blue-500 mx-auto mt-6" />
    </div>
  );
}
